import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoInfo16 } from '@onefootprint/icons';
import * as Label from '@radix-ui/react-label';
import { cx } from 'class-variance-authority';
import Tooltip from '../../tooltip';
export type LabelTooltipProps = {
  text: string;
  triggerAriaLabel?: string;
  iconComponent?: Icon;
};
type FormLabelLabelProps = {
  children: string | React.ReactNode;
  hasError?: boolean;
  htmlFor?: string;
  id?: string;
  size?: 'default' | 'compact' | 'tiny';
  tooltip?: LabelTooltipProps;
};
const FormLabel = t0 => {
  const $ = _c(11);
  const {
    children,
    hasError: t1,
    htmlFor,
    id,
    size: t2,
    tooltip
  } = t0;
  const hasError = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  const t3 = size === "compact" || size === "tiny";
  let t4;
  if ($[0] !== hasError || $[1] !== t3) {
    t4 = cx("fp-label fp-custom-appearance flex gap-1 items-center text-label-2 text-primary", {
      "text-caption-1": t3,
      "text-error": hasError
    });
    $[0] = hasError;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== tooltip) {
    t5 = tooltip && <Tooltip disabled={!tooltip.text} content={tooltip.text}>{tooltip?.iconComponent ? <tooltip.iconComponent /> : <IcoInfo16 />}</Tooltip>;
    $[3] = tooltip;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== htmlFor || $[7] !== id || $[8] !== t4 || $[9] !== t5) {
    t6 = <Label.Root className={t4} htmlFor={htmlFor} id={id}>{children}{t5}</Label.Root>;
    $[5] = children;
    $[6] = htmlFor;
    $[7] = id;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default FormLabel;